<div *ngIf="!generalDestinationType" [class.hidden]="!isLoaded" [id]="mapId" class="map-wrapper"></div>
<div *ngIf="generalDestinationType" class="general-wrapper">
    <app-svg-loader *ngIf="generalDestinationType === 'Beach'" color="#0000" height="38px"
        url="assets/svg/beach.svg"></app-svg-loader>
    <app-svg-loader *ngIf="generalDestinationType === 'Mountain'" height="38px"
        url="assets/svg/mountain.svg"></app-svg-loader>
</div>

<div class="map-loading-wrapper" *ngIf="!isLoaded">
    <!-- VAR -->
    <app-spinner color="var(--white)" barColor="#2d88d6"></app-spinner>
</div>